// extracted by mini-css-extract-plugin
export default {"card":"TrendsandAnalysis_card__pxYVk","accordionWrapper":"TrendsandAnalysis_accordionWrapper__kFW-b","icon":"TrendsandAnalysis_icon__z8-IJ"};